import { useBrand } from "@/config/brands";

/**
 * Provenance line for the sibling brands.
 *
 * Luigi's and AntiGreed present the pricing data but do not gather it — the
 * chargemaster ingestion, normalization and national averages all happen on
 * AHP. Stating that plainly (with a link people can actually follow) is both
 * honest attribution and the thing that makes the numbers checkable.
 *
 * Renders nothing on AHP itself, which would otherwise be citing itself.
 * Colours follow the brand so this reads as part of the page rather than a
 * bolted-on credit.
 */
export function DataSourceAttribution() {
  const brand = useBrand();
  if (brand.key === 'ahp') return null;

  const luigis = brand.key === 'luigis';
  const bodyColor = luigis ? 'rgba(0,255,0,0.62)' : '#e8d4b0';
  const linkColor = luigis ? '#00ffff' : '#ff6600';

  return (
    <div className="px-6 pb-24 pt-2 text-center">
      <p className="text-xs" style={{ color: bodyColor, opacity: luigis ? 1 : 0.75 }}>
        Pricing data sourced from{' '}
        <a
          href="https://americanhospitalprices.com"
          target="_blank"
          rel="noopener noreferrer"
          className="underline underline-offset-2"
          style={{ color: linkColor }}
        >
          americanhospitalprices.com
        </a>
        {' '}&mdash; compiled from each hospital&rsquo;s published chargemaster.
      </p>
    </div>
  );
}
